import { DeleteOutlined } from "@ant-design/icons";
import { Button, Input, Popconfirm, message } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Avatar1, morning_img_02, morning_img_03 } from "../../imagepath";
import { extractPatientIdFromUrl } from "../../../utils/helpers";
import { post, postFormData } from "../../../services/base";
import {procedenciasCode} from "../../../utils/enums/statusCodes";
import { DocumentacionContext } from "../../../context/DocumentacionContext";
import { handleDescargarArchivo } from "../../../services/api";

const Documentacion = () => {
  const [activeTab, setActiveTab] = useState("comentarios");
  const [comentario, setComentario] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [files, setFiles] = useState([]);
  const [nuevoNombreArchivo, setNuevoNombreArchivo] = useState("");
  const [longitudComentario, setLongitudComentario] = useState(0);
  const [loading, setLoading] = useState(false);
  const { documentacionesAfiliados, comentariosAfiliados, actualizarComentarios, actualizarDocumentaciones, eliminarComentario, eliminarArchivo } =
  useContext(DocumentacionContext);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  
  const handleDescripcionChange = (e) => {
    const text = e.target.value;
    setDescripcion(text);
    setLongitudComentario(text.length);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const newFile = {
        name: selectedFile.name,
        size: selectedFile.size,
        type: selectedFile.type,
        file: selectedFile,
      };
      setFiles(newFile);
      setNuevoNombreArchivo(selectedFile.name);
    }
  };

  const handleCommentChange = (e) => {
    const text = e.target.value;
    setComentario(text);
    setLongitudComentario(text.length);
  };

  const handleEliminarComentario = async (comentario) => {
    try{
      await eliminarComentario(comentario);
      actualizarComentarios();
      message.success("Comentario eliminado.");
    }catch(error){
      console.error("Error eliminado comentario:", error);
      message.error("Error eliminado comentario. Por favor, inténtelo de nuevo más tarde.");
    }
  };

  const handleEliminarArchivo = async (documentacion) => {
    try{
      await eliminarArchivo(documentacion);
      actualizarDocumentaciones();
      message.success("Documento eliminada.");
    }catch(error){
      console.error("Error eliminado documento:", error);
      message.error("Error eliminado documento. Por favor, inténtelo de nuevo más tarde.");
    }
  };

  const handleAgregarComentario = async () => {
    try {
      setLoading(true);
      const formDataToSend = {
        afiliado: extractPatientIdFromUrl(),
        procedencia: procedenciasCode.General.value,
        comentario: comentario
      };
      await post('/Documentacion/comentario',JSON.stringify(formDataToSend));
      message.success("Comentario agregado.");
      setComentario('');
      actualizarComentarios();
      setLoading(false);

    } catch (error) {
      setLoading(false);
      console.error("Error agregando comentario:", error);
      message.error("Error agregando comentario. Por favor, inténtelo de nuevo más tarde.");
    }
  };

  const handleAgregarDocumentacion = () => {
    if (files) {
      setLoading(true);
      const formData = new FormData();
      formData.append('Archivo',  files.file);
      formData.append('Procedencia', procedenciasCode.General.value);
      formData.append('Afiliado', extractPatientIdFromUrl());
      formData.append('Nombre', descripcion);
      
      postFormData('/Documentacion/archivo', formData)
        .then(response => {
          if (!response.status === 200) {
            throw new Error('Error al enviar el archivo');
          }
          message.success(`¡Archivo '${files.name}' subido exitosamente!`);
          actualizarDocumentaciones();
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          console.error('Error:', error);
        });
    }
  };
  
  
  return (
    <div style={{'paddingTop' : '0px', height: '1200px'}}>
    <div className="row mt-4">
      <div className="col-xl-3 col-md-4">
        <div className="widget settings-menu setting-list-menu">
        <ul className="mb-0">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "archivos" ? "active" : ""}`}
              onClick={() => handleTabChange("archivos")}
              style={{ color: activeTab === "archivos" ? "var(--primary-color)" : "inherit" }}
            >
              <i style={{fontSize: "15px"}} className="fa fa-file-alt me-2" /> <span style={{fontSize: "14px"}}>Archivos</span>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "comentarios" ? "active" : ""}`}
              onClick={() => handleTabChange("comentarios")}
              style={{ color: activeTab === "comentarios" ? "var(--primary-color)" : "inherit" }}
            >
              <i style={{fontSize: "15px"}} className="fa fa-comment me-2" /> <span style={{fontSize: "14px"}}>Comentarios</span>
            </button>
          </li>
        </ul>
        </div>
      </div>
      <div className="col-xl-9 col-md-8" style={{'paddingTop' : '0px', height: '1200px'}}>
        {activeTab === "comentarios" && (
          <div className="card invoices-settings-card-documentacion">
            <div className="card-body">
              <form action="#" className="invoices-settings-form" style={{marginLeft : "10px"}}>
                <Input.TextArea
                  placeholder="Agregar un comentario"
                  value={comentario}
                  onChange={handleCommentChange}
                  maxLength={255}
                  autoSize={{ minRows: 2, maxRows: 6 }}
                />
                <h5 style={{marginTop: "10px", fontSize: "12px"}}>Caracteres {longitudComentario}/255</h5>

                <Button
                    type="primary"
                    className="btn btn-primary add-pluss ms-2"
                    style={{ marginTop: "10px", marginRight: "10px"}}
                    loading={loading}
                    disabled={comentario.length === 0}
                    onClick={handleAgregarComentario}>
                      
                    Guardar
                </Button>
                {comentariosAfiliados.length === 0 ? (
                  <div className="no-comment-message-documentacion">
                    <img src={morning_img_02} alt="No data" />
                    <p style={{ marginTop: "10px" }}>
                      Este paciente no registra comentarios.
                    </p>
                  </div>
                ) : (
                  comentariosAfiliados.map((comentario, index) => (
                    <div
                      key={index}
                      className="comment-container-documentacion"
                    >
                      <div
                        className="comment-content-documentacion"
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            width={28}
                            height={28}
                            className="rounded-circle"
                            src={Avatar1}
                            alt="#"
                          />
                          <p style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "5px", marginLeft: "8px" }}>
                            {comentario.gestor} - 
                          </p><h5 style={{marginBottom: "2px", marginLeft: "8px"}}>{comentario.fecha}</h5>
                        </div>
                        <p style={{ fontSize: "16px", marginTop: "10px", marginLeft: "10px" }}>{comentario.comentario}</p>
                      </div>
                      <div
                        className="comment-action-container-documentacion"
                      >
                        <Popconfirm
                          title="¿Está seguro de que desea eliminar este comentario?"
                          onConfirm={() => handleEliminarComentario(comentario)}
                          okText="Sí"
                          cancelText="Cancelar"
                        >
                          <Button
                            type="link"
                            icon={<DeleteOutlined style={{ color: "white" }} />}
                            style={{ padding: 0 }}
                          />
                        </Popconfirm>
                      </div>
                    </div>
                  ))
                )}
              </form>
            </div>
          </div>
        )}
        {activeTab === "archivos" && (
          <div className="card invoices-settings-card" style={{ maxHeight: "1200px", overflowY: "auto" }}>
            <div className="card-body">
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  {/* Contenido para cargar archivos */}
                </div>
                <div>

                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                  <div style={{ padding: "10px", borderRadius: "5px", width: "100%", display: "flex", alignItems: "center" }}>
                    <input type="file" id="fileInput" style={{ display: "none" }} onChange={handleFileChange} />
                    <button onClick={() => document.getElementById("fileInput").click()} style={{ border: "1.5px solid green", borderRadius: "5px", background: "transparent", outline: "none", color: "green", fontSize: "12px", padding: "8px" }}>Adjuntar archivo</button>
                    {nuevoNombreArchivo && (
                      <div style={{ marginLeft: "15px", marginTop: "14px" }}>
                        <h5 style={{fontSize: "12px"}}>{nuevoNombreArchivo}</h5>
                      </div>
                    )}
                  </div>
                  <Input.TextArea
                    placeholder="Nombre archivo"
                    onChange={handleDescripcionChange}
                    maxLength={255}
                    style={{ marginLeft: "10px", width: "100%" }}
                    autoSize={{ minRows: 1, maxRows: 3 }}
                  />
                  <h5 style={{ marginTop: "10px", fontSize: "12px", marginLeft: "10px" }}>Caracteres {longitudComentario}/255</h5>
                  <Button
                    key="save"
                    type="primary"
                    onClick={handleAgregarDocumentacion}
                    loading={loading}
                    disabled={files.length === 0}
                    className="btn btn-primary add-pluss ms-2"
                    style={{ marginTop: "10px", marginLeft: "10px"}}
                  >
                    Guardar
                  </Button>
                </div>

                {documentacionesAfiliados && documentacionesAfiliados.length > 0 ? (
                  documentacionesAfiliados.map((archivo, index) =>   (
                    <div style={{marginTop:"25px"}}>
                    <h5 style={{marginBottom: "10px", marginLeft: "8px", color: "var(--primary-blue)", fontSize: "15px", fontWeight: "bold"}}>{archivo.fecha}</h5>
                    <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                      <div
                        style={{
                          backgroundColor: "#f5f5f5",
                          borderRadius: "8px",
                          padding: "8px",
                          flexDirection: "column",
                          flexGrow: 1,
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {/* Imagen */}
                          <img
                            width={28}
                            height={28}
                            className="rounded-circle"
                            src={Avatar1}
                            alt="#"
                          />
                          {/* Nombre del gestor */}
                          <p style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "5px", marginLeft: "8px" }}>
                            {archivo.gestor} - 
                          </p><h5 style={{marginBottom: "3px", marginLeft: "8px"}}>{archivo.fecha}</h5>

                        </div>
                      {/* Mostrar el comentario */}
                        <div onClick={() => handleDescargarArchivo(archivo.descripcion)} style={{ backgroundColor: 'var(--primary-blue)', color: '#fff', padding: '8px', width:'100%', borderRadius: '4px', transition: 'background-color 0.3s', cursor: 'pointer', marginTop:"10px" }}>
                            <a rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                              {archivo.descripcion}
                            </a>
                          </div>
                        </div>
                      <div style={{ marginLeft: '8px', height: '100%',backgroundColor: 'rgb(255, 153, 153)', borderRadius: '4px', padding: '7px', height: 'auto' }}>
                        <Popconfirm
                          title="¿Está seguro de que desea eliminar este archivo?"
                          onConfirm={() => handleEliminarArchivo(archivo)}
                          okText="Sí"
                          cancelText="Cancelar"
                        >
                          <Button
                            type="link"
                            icon={<DeleteOutlined style={{ color: 'white' }} />}
                            style={{ padding: 0, height: '100%' }}
                          />
                        </Popconfirm>
                      </div>
                    </div>
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      marginLeft: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <img src={morning_img_03} alt="No data" />
                    <p style={{ marginTop: "10px" }}>
                      Este paciente no tiene archivos relacionados.
                    </p>
                  </div>
                )}
                </div>
            </div>
          </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default Documentacion;
